module.exports = __webpack_public_path__ + "static/img/footer-menu-icon02.a9084c28.svg";